/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlannerItineraryItem } from './PlannerItineraryItem';
import {
    PlannerItineraryItemFromJSON,
    PlannerItineraryItemFromJSONTyped,
    PlannerItineraryItemToJSON,
    PlannerItineraryItemToJSONTyped,
} from './PlannerItineraryItem';

/**
 * 
 * @export
 * @interface PlannerItineraryResponse
 */
export interface PlannerItineraryResponse {
    /**
     * 
     * @type {Array<PlannerItineraryItem>}
     * @memberof PlannerItineraryResponse
     */
    items: Array<PlannerItineraryItem>;
}

/**
 * Check if a given object implements the PlannerItineraryResponse interface.
 */
export function instanceOfPlannerItineraryResponse(value: object): value is PlannerItineraryResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function PlannerItineraryResponseFromJSON(json: any): PlannerItineraryResponse {
    return PlannerItineraryResponseFromJSONTyped(json, false);
}

export function PlannerItineraryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlannerItineraryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(PlannerItineraryItemFromJSON)),
    };
}

export function PlannerItineraryResponseToJSON(json: any): PlannerItineraryResponse {
    return PlannerItineraryResponseToJSONTyped(json, false);
}

export function PlannerItineraryResponseToJSONTyped(value?: PlannerItineraryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(PlannerItineraryItemToJSON)),
    };
}

